// Avoid importing SDKs for tree-shaking purposes
const CANCELLED_ERROR_CODE = 1;

export function isPurchaseCancelledError(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) return false;

  // Check for JS SDK error shape (has errorCode property)
  if ('errorCode' in error) {
    return Number(error.errorCode) === CANCELLED_ERROR_CODE;
  }

  // Check for Capacitor SDK error shape (has code property)
  if ('code' in error) {
    return Number(error.code) === CANCELLED_ERROR_CODE;
  }

  return false;
}
